
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useAuthStore } from '../../stores/auth';
import { showVuePopup } from '../../utils/showVuePopup';
import Favorite from '../../popup/Favorite.vue';
import Recently from '../../popup/Recently.vue';

export default {
	name: 'GameNavbar',
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const menus = ref([
			{ name: 'Demo', href: '/demo', image: 'https://placehold.co/400/webp?text=demo', show: false },
			{ name: 'Favorite', handle: () => showVuePopup(Favorite), image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-fav.webp', show: auth.isLoggedIn },
			{ name: 'Recently', handle: () => showVuePopup(Recently), image: 'https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/btn-play-recommended.webp', show: auth.isLoggedIn },
			{ name: 'Recommended', href: '/recommended', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-play-m-hot.webp', show: true },
			{ name: 'Slot', href: '/slot', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-slot.webp', show: true },
			{ name: 'Casino', href: '/casino', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-casino.webp', show: true },
			{ name: 'Poker', href: '/poker', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-poker.webp', show: true },
			{ name: 'Card', href: '/card', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-card.webp', show: true },
			{ name: 'Fish Hunter', href: '/fishhunter', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-fishhuter.webp', show: true },
			{ name: 'Lotto', href: '/lotto', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-lotto.webp', show: true },
			{ name: 'Sport', href: '/sport', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-sport.webp', show: true },
			{ name: 'Keno', href: '/keno', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-keno.webp', show: true },
			{ name: 'Trade', href: '/trade', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-trade.webp', show: true },
			{ name: 'Cockfighting', href: '/cockfighting', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-ch.webp', show: true },
			{ name: 'E-Sport', href: '/esport', image: 'https://tos168.sgp1.cdn.digitaloceanspaces.com/btn-tab-esport.webp', show: true },
		]);

		return {
			profile,
			menus,
		};
	},
}
